import React from 'react';

import Router from './Router';

const Supporter: React.FC = () => {
  return (
    <div className="container-fluid">
      <Router />
    </div>
  );
};
export default Supporter;
